globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.GoogleMyBusiness = appCustomerSpace.Controllers.GoogleMyBusiness || {};

appCustomerSpace.Controllers.GoogleMyBusiness.AttributesController = (function(superClass) {

    utils.extend(AttributesController, superClass);

    function AttributesController() {
        this.$form = $('form.location-attributes-form');
        return AttributesController.__super__.constructor.apply(this, arguments);
    }

    $.extend(AttributesController.prototype, {
        init: function(){
            this.initEvents();

            return AttributesController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            // Add/Delete checkbox
            this.$form.find('.add-or-delete-attribute').on('click', function(e){
                var $checkbox = $(this),
                    $attributeItemWrapper = $checkbox.closest('.attribute-item-wrapper'),
                    $radioTrue = $attributeItemWrapper.find("#radio-true input[type='radio']"),
                    $radioFalse = $attributeItemWrapper.find("#radio-false input[type='radio']"),
                    $radioTrueSpan = $attributeItemWrapper.find("#radio-true span"),
                    $radioFalseSpan = $attributeItemWrapper.find("#radio-false span");

                if ($radioFalseSpan.hasClass('checked')) {
                    $radioFalseSpan.removeClass('checked')
                    $radioFalse[0].value = "";
                };
                if ($radioTrueSpan.hasClass('checked')) {
                    $radioTrueSpan.removeClass('checked')
                    $radioTrue[0].value = "";
                };
            });
        }
    });

    return AttributesController;

})(appCustomerSpace.Controllers.GoogleMyBusiness.MainController);
